import { render, staticRenderFns } from "./LocationAdministrationOverviewTable.vue?vue&type=template&id=06935e89&scoped=true&"
import script from "./LocationAdministrationOverviewTable.vue?vue&type=script&lang=js&"
export * from "./LocationAdministrationOverviewTable.vue?vue&type=script&lang=js&"
import style0 from "./LocationAdministrationOverviewTable.vue?vue&type=style&index=0&id=06935e89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06935e89",
  null
  
)

/* custom blocks */
import block0 from "./LocationAdministrationOverviewTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06935e89')) {
      api.createRecord('06935e89', component.options)
    } else {
      api.reload('06935e89', component.options)
    }
    module.hot.accept("./LocationAdministrationOverviewTable.vue?vue&type=template&id=06935e89&scoped=true&", function () {
      api.rerender('06935e89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/location-administration/LocationAdministrationOverviewTable.vue"
export default component.exports